import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { contact, whatsappUrl } from '../content/siteContent';
import Brand from './Brand';

const { FiMessageCircle, FiFacebook, FiMapPin, FiArrowUp } = FiIcons;

const links = [
  ['Inicio', '#inicio'],
  ['Servicios', '#servicios'],
  ['Cómo funciona', '#como-funciona'],
  ['Cobertura', '#cobertura'],
  ['Para negocios', '#negocios'],
  ['Contacto', '#contacto']
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <Brand />
          <p>Tú pide, que nosotros hacemos el mandao.</p>
        </div>
        <div className="footer__links">
          <h3>Explora</h3>
          {links.map(([label, href]) => <a href={href} key={href}>{label}</a>)}
        </div>
        <div className="footer__contact">
          <h3>Contacto</h3>
          <a href={whatsappUrl()} target="_blank" rel="noreferrer">
            <SafeIcon icon={FiMessageCircle} /> {contact.phoneDisplay}
          </a>
          <span><SafeIcon icon={FiMapPin} /> Bonao, Monseñor Nouel</span>
          <a href={contact.facebookUrl} target="_blank" rel="noreferrer">
            <SafeIcon icon={FiFacebook} /> @mandaobonao
          </a>
        </div>
      </div>
      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} Muchacho E’ Mandao. Todos los derechos reservados.</span>
        <div><a href="#privacidad">Política de privacidad</a><a href="#terminos">Términos y condiciones</a></div>
        <a href="#inicio">Volver arriba <SafeIcon icon={FiArrowUp} /></a>
      </div>
    </footer>
  );
}

export default Footer;